import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { PapiDeviation } from '@wix/da-papi-types';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { getDeviationUrl } from '../_helpers';

export function useDeviationSeoData(deviation: PapiDeviation) {
  const isLoggedIn = useSelector(getIsLoggedIn);
  return useMemo(() => {
    if (isLoggedIn) {
      return false;
    }

    const author = deviation.author?.username;
    const isAi = deviation.isAiGenerated;
    return Object.fromEntries(Object.entries({
      creator: author ?? 'Anonymous',
      creditText: author
        ? `${author} on DeviantArt`
        : `DeviantArt`,
      license: deviation.license && deviation.license.startsWith('by') &&
        `http://creativecommons.org/licenses/${deviation.license}/3.0/`,
      acquireLicensePage: !isAi && getDeviationUrl(deviation),
      copyrightNotice: !isAi && author,
    }).filter(([key, val]) => !!val));
  }, [isLoggedIn, deviation]);
}
